/**
 * PQRPostWeldHeatTable Component
 * 
 * Reusable component for rendering Post Weld Heat Treatment table (QW-407) in PQR PDFs
 */

import React from "react";
import { getPQRValue } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRPostWeldHeatTable = ({ pdf }) => {
  const pdfData = pdf[0];

  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">POST WELD HEAT TREATMENT(QW-407)</div>
      </div>
      <table id="table" className="PQRpwhtTable" cellSpacing="0">
        <tbody>
          <tr>
            <th style={{ width: "10.8%", borderBottom: "0", borderTop: "1px solid black" }}>
              Temperature
              <div className="PQRrcorner"> °C </div>
            </th>
            <td style={{ width: "13%", borderTop: "1px solid black" }}>
              {getPQRValue(pdfData?.PQR_PWHeatTre_Temperature)}
            </td>
            <th style={{ width: "9.8%", borderBottom: "0", borderTop: "1px solid black" }}>
              Time
              <div className="PQRrcorner"> Minutes</div>
            </th>
            <td style={{ width: "20%", borderBottom: "0", borderLeft: "none", borderTop: "1px solid black" }}>
              {getPQRValue(pdfData?.PQR_PWHeatTre_Time)}
            </td>
            <th rowSpan="3" style={{ width: "4%", borderBottom: "1px solid black", borderLeft: "1px solid black", borderTop: "1px solid black" }}>
              Type
            </th>
            <td rowSpan="3" style={{ width: "13%", borderBottom: "1px solid black", borderLeft: "none", borderTop: "1px solid black", borderRight: "1px solid black" }}>
              {getPQRValue(pdfData?.PQR_PWHeatTre_Type)}
            </td>
          </tr>
          <tr>
            <th style={{ width: "25%", borderBottom: "0", borderTop: "0" }}>
              Heating Rate
              <div className="PQRrcorner"> °C/hr </div>
            </th>
            <td style={{ width: "15%", borderLeft: "none" }}>
              {getPQRValue(pdfData?.PQR_PWHeatTre_Heating_Rate)}
            </td>
            <th style={{ width: "15%", borderBottom: "0", borderTop: "0" }}>
              Loading Temp.<div className="PQRrcorner"> °C </div>
            </th>
            <td style={{ width: "25%", borderLeft: "none" }}>
              {getPQRValue(pdfData?.PQR_PWHeatTre_Heating_Method)}
            </td>
          </tr>
          <tr>
            <th style={{ width: "25%", borderTop: "0" }}>
              Cooling Rate
              <div className="PQRrcorner"> °C/hr </div>
            </th>
            <td style={{ width: "15%", borderBottom: "1px solid black", borderLeft: "none" }}>
              {getPQRValue(pdfData?.PQR_PWHeatTre_Cooling_Rate)}
            </td>
            <th style={{ width: "15%", borderTop: "0" }}>
              Unloading Temp. <div className="PQRrcorner"> °C </div>
            </th>
            <td style={{ width: "25%", borderTop: "0", borderBottom: "1px solid black", borderLeft: "none" }}>
              {getPQRValue(pdfData?.PQR_PWHeatTre_Cooling_Method)}
            </td>
          </tr>
          <tr>
            <th className="PQR_noTop">Notes</th>
            <td colSpan="5" className="PQR_rt_botm" style={{ textAlign: "left" }}>
              {getPQRValue(pdfData?.PQR_PWHeatTre_Notes)}
            </td>
          </tr>
        </tbody>
      </table>
      <table id="table" className="PQRpwhtTable">
        <tbody>
          <tr>
            <td style={{ width: "7.7%" }}></td>
            <th style={{ width: "28%" }} className="PQR_noTop">
              Preheat maintenance after completion of welding prior to PWHT ( QW-406.2)
            </th>
            <td style={{ width: "15%" }} className="PQR_noTopnoLft">
              {getPQRValue(pdfData?.PQR_PWHeatTre_Maintenance)}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default PQRPostWeldHeatTable;